import React from "react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { AlertTriangle } from "lucide-react";

// ctx: { nome, extra?, action } — action eseguita alla conferma
export function ConfirmUndoDialog({ ctx, onClose }) {
  return (
    <Dialog open={!!ctx} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="confirm-undo-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><AlertTriangle size={18} className="text-amber-500" /> {ctx?.titolo || "Togliere la spunta?"}</DialogTitle>
          <DialogDescription>{ctx?.testo ? <>{ctx.testo} <b>{ctx?.nome}</b>?</> : <>Vuoi davvero togliere la spunta di <b>{ctx?.nome}</b>{ctx?.extra ? ` — ${ctx.extra}` : ""}? L'operazione può essere rifatta in qualsiasi momento.</>}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="confirm-undo-cancel">Annulla</Button>
          <Button variant="destructive" onClick={() => { const a = ctx?.action; onClose(); if (a) a(); }} data-testid="confirm-undo-ok">{ctx?.ok || "Sì, togli la spunta"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
